import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';

export interface EncompassField {
  id: string;
  description: string;
  dataType: string;
  jsonPath: string;
  contractPath: string;
  nullable: boolean;
  readOnly: boolean;
  multiInstance: boolean;
  category: string;
  format: string;
  fieldLock: boolean;
  maxLength: number;
  entitiesFilterKey?: string;
  options?: Array<{ value: string; text: string }>;
}

export interface EncompassFieldSchemaResponse {
  success: boolean;
  fields: EncompassField[];
}

const _mock: EncompassFieldSchemaResponse = {
  success: true,
  fields: [],
};

const getEncompassFieldSchema: QueryFunction<
  EncompassFieldSchemaResponse,
  ['/shared/encompass/field-schema', string | undefined]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mock);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const fieldIds = queryKey[1];

  const url = fieldIds
    ? `/shared/encompass/field-schema?fieldIds=${encodeURIComponent(fieldIds)}`
    : '/shared/encompass/field-schema';

  const response = await authTokenHttp<EncompassFieldSchemaResponse>(url, {
    method: 'GET',
  });

  if (response.data) return response.data;
  throw new Error('Failed to fetch Encompass field schema');
};

export default getEncompassFieldSchema;
